module.exports = __webpack_public_path__ + "img/1.d88ecef6.png";